export const API_URL = import.meta.env.VITE_API_URL;
export const BORROWER_API_URL = import.meta.env.VITE_BORROWER_API_URL;
export const LENDER_API_URL = import.meta.env.VITE_LENDER_API_URL;
export const TEST_ENVIRONMENT = import.meta.env.VITE_TEST_ENVIRONMENT === '1';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
